export default __webpack_public_path__ + "media/color/gup-8caed576.svg";